module.exports = __webpack_public_path__ + "img/expovina_01.58f394f0.jpg";